<template>
    <div class="paymask ignore">
        <div class="payinner" style=" width: 368px;height: 406px;">
            <i class="el-icon-close" @click="clo"></i>
            <div class="payTitle" style="font-weight: 600;font-size: 18px;color: #000000;padding-top: 20px;">
                微信扫码支付
            </div>
            <div class="qroces" style="width: 160px;height: 160px;background: #fff;margin: 30px auto 12px;">
                <canvas ref="qrCanvas"></canvas>
            </div>
           <div class="tips" style=" font-size: 15px;margin-bottom: 6px;">
                请使用微信扫码完成支付
            </div>
            <div class="orderNo" style="margin-bottom: 26px;">
                订单号:{{orderNo}}
            </div>
            <div>
                <el-button plain @click="checkOrderpay">我已完成支付</el-button>
                <el-button @click="clo" type="primary">关闭</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        checkorderpay
    } from "@/api/index.js"
    import QRCode from 'qrcode'
    export default {
        name: 'wechatpay',
        props:['type','source','codeUrl','orderNo'],
        data() {
            return {
                activeIndex: "1",
                list: []
            }
        },
        created() {
            
        },
        mounted() {
            this.renderQrCode()
            console.log(this.codeUrl)
        },
        methods: {
            async renderQrCode() {
                try {
                    await QRCode.toCanvas(this.$refs.qrCanvas, this.codeUrl, {
                        width: 160,
                        margin: 2,
                        color: {
                            dark: '#000000',
                            light: '#ffffff'
                        }
                    })
                } catch (err) {
                    console.error('二维码生成失败', err)
                }
            },
            clo(){
                this.$emit("close")
            },
            checkOrderpay() {
                let that = this
                let data = that.orderNo
                checkorderpay(data).then((res) => {
                    if (res.code == 1) {
                        if (res.data.is_pay_ok == 1) {
                            that.clo()
                            setTimeout(() => {
                                if(that.type == 'activity'){
                                    if(that.source == 'order'){
                                       that.$router.push({
                                           path: '/homeSuccess', // 写路由path
                                           query: {
                                               txt:'恭喜您，支付成功!'
                                           }
                                       })
                                    }else{
                                        that.$emit("rfh")
                                    }
                                }else if(that.type == 'books'){
                                    if(that.source == 'order'){
                                        that.$router.push({
                                            path: '/homeSuccess', // 写路由path
                                            query: {
                                                txt:'恭喜您，支付成功!'
                                            }
                                        })
                                    }else{
                                        that.$emit("rfh")
                                    }
                                }else if(that.type == 'shortMessage'){
                                    that.$emit("rfh")
                                }else{
                                    
                                }
                                
                            }, 2000)
                        } else {
                            that.$message.warning('暂未查询到订单支付结果，请稍后再试')
                        }
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .orderNo {
       
    }

    .tips {
       
    }

    .qroces {
      
    }

    .paymask {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 18999 !important;
        text-align: center;
    }

    .payinner {
       
        background: url('https://two.hrxsl.com/pcImages/paybk.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .el-icon-close {
        font-size: 18px;
        position: absolute;
        top: 25px;
        right: 20px;
        font-weight: bold;
        cursor: pointer;
    }

    .payTitle {
        
    }
</style>